import { Box, Theme, Typography } from "@mui/material";
import OrderSummary from "./orderSummary";
import OrderHistory from "./orderHistory";
import { CommonLayout } from "../../commonComponents";

export default function OrderDashboard(): JSX.Element {
    return (
        <Box>
            <Typography
                variant="h1"
                sx={(theme: Theme) => ({
                    lineHeight: "32.5px",
                    color: theme.palette.text.primary
                })}
            >
                Order Dashboard
            </Typography>

            {/* Order Summary and Order History */}

            <OrderSummary />
            <OrderHistory />
        </Box>
    )
}